export default "__VITE_ASSET__HcV70wXs__"